import * as _4 from 'lodash4';
import { IContact, IContactCourse } from '../contact_interfaces';

export class ContactsService {
  private _mobileScrollDelegate: any;

  constructor() {
    // tslint:disable-next-line:no-empty
    this._mobileScrollDelegate = () => {};
  }

  createInitials(contact: IContact): string {
    if (_4.isEmpty(contact.first_name) || _4.isEmpty(contact.last_name)) {
      return '--';
    }

    return _4
      .map(_4.words(`${contact.first_name} ${contact.last_name}`), (word: string) => {
        return _4.capitalize(word)[0];
      })
      .join('')
      .slice(0, 3);
  }

  relationshipText(contact: IContact): string {
    if (_4.isEmpty(contact.courses)) {
      return contact.relationship;
    }
    return this.getCourseString(contact);
  }

  getCourseString(contact: IContact): string {
    if (_4.isEmpty(contact)) {
      return '';
    }
    return _4
      .reduce(
        contact.courses,
        (arr: string[], course: IContactCourse) => {
          arr.push(course.code);
          return arr;
        },
        []
      )
      .join(', ');
  }

  setMobileScrollDecorator(scrollDelegate: any): void {
    this._mobileScrollDelegate = scrollDelegate;
  }

  callMobileScrollDecorator(): void {
    _4.result(this._mobileScrollDelegate, 'resize');
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/services/contact_service.ts